import { useRef } from "react";
import { get, post, put } from "../../app/api";

/**
 * Hook for API requests that don't dispatch errors to Redux.
 * Errors are caught silently and returned with isError flag.
 * Useful for optional requests where errors shouldn't show in global alerts.
 */
export default function useSilentApiRequest() {
  const abortController = useRef(new AbortController());

  const silentGet = async (url: string) => {
    try {
      const result = await get(url, abortController.current.signal);
      return result;
    } catch (err) {
      return { isError: true, errorTable: [], result: null };
    }
  };

  const silentPost = async <T,>(url: string, data?: T) => {
    try {
      const result = await post(url, data, abortController.current.signal);
      return result;
    } catch (err) {
      return { isError: true, errorTable: [], result: null };
    }
  };

  const silentPut = async <T,>(url: string, data?: T) => {
    try {
      const result = await put(url, data, abortController.current.signal);
      return result;
    } catch (err) {
      return { isError: true, errorTable: [], result: null };
    }
  };

  return { get: silentGet, post: silentPost, put: silentPut };
}
